module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik00MjctMTIwdi0yMjVoNjB2ODNoMzUzdjYwSDQ4N3Y4MmgtNjBabS0zMDctODJ2LTYwaDI0N3Y2MEgxMjBabTE4Ny0xNjZ2LTgySDEyMHYtNjBoMTg3di04NGg2MHYyMjZoLTYwWm0xMjAtODJ2LTYwaDQxM3Y2MEg0MjdabTE2Ni0xNjV2LTIyNWg2MHY4MmgxODd2NjBINjUzdjgzaC02MFptLTQ3My04M3YtNjBoNDEzdjYwSDEyMFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/filter.svg
// module id = 8FIl
// module chunks = 0